/**
 * WORK-ORDER-BREADCRUMB.JSX - Breadcrumb Navigation Component for Work Order
 * 
 * SUMMARY:
 * Presentational component that renders breadcrumb navigation for work order pages.
 * Shows navigation path: Projects > Project Name > WO List > Create/Edit Work Order
 * 
 * PROPS:
 * @param {string} projectType - Project type for filtering project list
 * @param {string} projectName - Name of current project (optional)
 * @param {boolean} poId - Whether editing existing WO (determines breadcrumb text)
 * @param {Function} viewProjectList - Handler for navigating to project list
 * @param {Function} viewProject - Handler for navigating to project detail
 * @param {Function} viewWoList - Handler for navigating to WO list
 */

import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

/**
 * Work Order Breadcrumb navigation component.
 * 
 * @component
 * @example
 * <WorkOrderBreadcrumb
 *   projectType="PROJECT"
 *   projectName="My Project"
 *   poId={null}
 *   viewProjectList={() => navigate('/projects')}
 *   viewProject={() => navigate('/projects/view/123')}
 *   viewWoList={() => navigate('/projects/work-order/123')}
 * />
 */
const WorkOrderBreadcrumb = ({
  projectType,
  projectName,
  poId,
  viewProjectList,
  viewProject,
  viewWoList
}) => {
  return (
    <div className="col-12 breadcrumb-block p-0" data-cy="breadcrumb">
      <Breadcrumb>
        <Breadcrumb.Item onClick={viewProjectList} data-cy="breadcrumb-projects">
          PROJECTS
        </Breadcrumb.Item>
        {projectName && (
          <Breadcrumb.Item onClick={viewProject}>
            {projectName}
          </Breadcrumb.Item>
        )}
        <Breadcrumb.Item onClick={viewWoList} data-cy="breadcrumb-wo-list">
          WO LIST
        </Breadcrumb.Item>
        <Breadcrumb.Item active data-cy="breadcrumb-work-order">
          {poId ? 'Edit Work Order' : 'Create Work Order'}
        </Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );
};

export default WorkOrderBreadcrumb;
